import { useSelector } from 'react-redux';
import { RootState } from '../store';

export const usePermissions = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  const isSupport = user?.scope === 'support';
  const isSuperAdmin = isSupport && !user?.role;
  const isBusinessSystemSupport = isSupport && !!user?.role;

  return {
    isSupport,
    isApiUser: user?.scope === 'api',
    isSuperAdmin,
    isBusinessSystemSupport,
    canViewAllClients: isSupport,
    canManageOrganizations: isSupport,
    canViewSystemSettings: isSupport,
    canDeleteClients: isSupport,
    canViewAuditLogs: isSupport,
    canLockClients: isSupport,
    canActivateClients: isSupport,
    canCycleSecrets: isSupport,
    organizationId: user?.organizationId,
    role: user?.role,
  };
};